import { useState, useEffect } from "react";
import axios from "axios";
import { Card, Title, DonutChart } from "@tremor/react";
import { getDateGranularity } from "../../helpers";
import { MixpanelService } from "../../_service/mixpanel.service";
import { withToast } from "../../contexts/toastr.context";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const base = process.env.REACT_APP_BASE_URL;

const DonutViewComponent = ({
  dateRange,
  event,
  property,
  profileProperty,
  title,
  maxCategories = 8,
  user,
}) => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const fromDate = dateRange[0].toISOString().split("T")[0];
      const toDate = dateRange[1].toISOString().split("T")[0];

      try {
        if (profileProperty) {
          const data = await MixpanelService.getProfilePropertyData(user, {
            profileProperty,
            from_date: fromDate,
            to_date: toDate,
          });
          setCategories(data.slice(0, maxCategories));
        } else {
          const data = await MixpanelService.getEventPropertyData(user, {
            event,
            property,
            from_date: fromDate,
            to_date: toDate,
            granularity: getDateGranularity(fromDate, toDate),
          });
          setCategories(data.slice(0, maxCategories));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [dateRange, event, property]);

  return (
    <Card className="flex flex-col">
      <Title>{title}</Title>
      <DonutChart
        className="h-96 p-5 m-auto text-5xl"
        data={categories}
        category="value"
        index="name"
        colors={[
          "cyan",
          "sky",
          "blue",
          "indigo",
          "violet",
          "purple",
          "fuchsia",
          "pink",
          "rose",
          "red",
          "orange",
          "amber",
          "yellow",
          "lime",
          "green",
          "emerald",
          "teal",
        ]}
      />
    </Card>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth,
});

const DonutView = withToast(
  withRouter(connect(mapStateToProps)(DonutViewComponent))
);

export default DonutView;
